module.exports = __webpack_public_path__ + "static/media/Shop-By-Tire-Size.2636adfd.svg";